import { render, staticRenderFns } from "./PriceUpdatingTaskAside.vue?vue&type=template&id=da06c41a&scoped=true&"
import script from "./PriceUpdatingTaskAside.vue?vue&type=script&lang=js&"
export * from "./PriceUpdatingTaskAside.vue?vue&type=script&lang=js&"
import style0 from "./PriceUpdatingTaskAside.vue?vue&type=style&index=0&id=da06c41a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da06c41a",
  null
  
)

export default component.exports